import { Currency } from '@/core/currency/interfaces';

const MYR: Currency = {
    name: 'Malaysian Ringgit',
    demonym: 'Malaysian',
    majorSingle: 'Ringgit',
    majorPlural: 'Ringgit',
    codeNumeric: '458',
    symbol: 'RM',
    symbolNative: 'RM',
    minorSingle: 'Sen',
    minorPlural: 'Sen',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MYR',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default MYR;
